import React, { useState } from 'react';
import { X, ArrowRight, Check, Copy, Clock, Loader2 } from 'lucide-react';

/* ─── Field helper ─── */
export function DInput({ label, value, onChange, type = 'text', placeholder, required, testId }) {
  const [touched, setTouched] = useState(false);
  const hasError = required && touched && !value.trim();
  return (
    <div>
      <label className="block text-[10px] uppercase tracking-[0.18em] mb-2 font-medium"
        style={{ color: 'var(--lux-text-muted-2)' }}>
        {label}
      </label>
      <input
        type={type} value={value}
        onChange={e => onChange(e.target.value)}
        onBlur={() => setTouched(true)}
        placeholder={placeholder}
        className={`landing-input${hasError ? ' error' : ''}`}
        data-testid={testId}
        autoComplete={type === 'email' ? 'email' : type === 'tel' ? 'tel' : 'off'}
      />
      {hasError && (
        <p className="text-[10px] mt-1.5" style={{ color: '#f87171' }}>Campo obbligatorio</p>
      )}
    </div>
  );
}

/* ─── Demo Success State ─── */
export function DemoSuccess({ result, t, lang, copied, onCopy, onReset }) {
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full flex items-center justify-center"
          style={{ background: 'rgba(5,150,105,0.15)' }}>
          <Check size={18} style={{ color: '#059669' }} />
        </div>
        <div>
          <h3 className="font-semibold text-sm" style={{ color: 'var(--lux-text)' }}>{t.demo_success_title}</h3>
          <p className="text-xs" style={{ color: 'var(--lux-text-muted)' }}>{t.demo_success_sub}</p>
        </div>
      </div>

      <div className="p-4 rounded-sm" style={{ background: 'var(--lux-surface-1)', border: '1px solid var(--lux-border-2)' }}>
        <p className="text-[10px] uppercase tracking-widest mb-3" style={{ color: 'var(--lux-gold)' }}>{t.demo_credentials}</p>
        <div className="space-y-2 text-xs">
          <div className="flex justify-between">
            <span style={{ color: 'var(--lux-text-muted)' }}>Email</span>
            <code style={{ color: 'var(--lux-text)' }}>{result.admin_email}</code>
          </div>
          <div className="flex justify-between">
            <span style={{ color: 'var(--lux-text-muted)' }}>Password</span>
            <code style={{ color: 'var(--lux-gold)' }}>{result.admin_password}</code>
          </div>
          <div className="flex justify-between">
            <span style={{ color: 'var(--lux-text-muted)' }}>Scade</span>
            <span style={{ color: 'var(--lux-text-muted)' }}>{result.expires_str}</span>
          </div>
        </div>
      </div>

      <a href={result.panel_url} target="_blank" rel="noreferrer"
        className="flex items-center justify-center gap-2 py-3.5 text-xs font-semibold tracking-widest uppercase w-full"
        style={{ background: 'var(--lux-gold)', color: '#000' }}
        data-testid="demo-open-panel-btn">
        {t.demo_open_panel} <ArrowRight size={13} />
      </a>

      <button onClick={() => onCopy(result.panel_url)}
        className="flex items-center justify-center gap-2 py-3 text-xs w-full"
        style={{ border: '1px solid var(--lux-border-2)', color: 'var(--lux-text-muted)' }}>
        {copied ? <><Check size={13} /> {t.demo_copied}</> : <><Copy size={13} /> {t.demo_copy}</>}
      </button>

      <div className="flex items-start gap-2 p-3 rounded-sm"
        style={{ background: 'rgba(201,168,76,0.05)', border: '1px solid rgba(201,168,76,0.12)' }}>
        <Clock size={12} style={{ color: 'var(--lux-gold)', flexShrink: 0, marginTop: 1 }} />
        <p className="text-[11px] leading-relaxed" style={{ color: 'var(--lux-text-muted)' }}>
          {t.demo_expires}. {t.demo_email_note}
        </p>
      </div>

      <button onClick={onReset} className="text-[11px] w-full text-center" style={{ color: 'var(--lux-text-muted-3)' }}>
        {lang === 'it' ? '← Crea un\'altra demo' : '← Create another demo'}
      </button>
    </div>
  );
}
